import {
    useMemo,
} from 'react'
import useRequest, {
    RequestFn, RequestKeys,
} from 'app/hooks/useRequest'
import {
    Fee, LaneFeesDetail,
} from 'app/Apps/Pricing/Pricing.types'
import LaneFeesRequests from 'app/requests/ContractBasis/LaneFees.requests'
import {
    LaneFeeTemplate,
} from 'app/enums/label.enums'

type Props = {
    laneGroupId: number | undefined
}
const useGetDefaultLaneFeesData = ({
    laneGroupId,
}: Readonly<Props>) => {
    const {
        data: feesTemplateData,
    } = useRequest<Fee[]>({
        key: RequestKeys.getLaneFeesTemplate,
        requestFunc: RequestFn.getEntity(LaneFeesRequests.getInitialLaneFees),
        params: {
            laneGroupId,
        },
        enabled: Boolean(laneGroupId),
    })

    return useMemo(() => {
        const initialData = {
            minOrder: 1,
            feeTemplate: LaneFeeTemplate.DETAILED_FEES_VIEW,
        }

        if (feesTemplateData?.length) {
            return {
                ...initialData,
                fees: feesTemplateData,
            }
        }
        return initialData
    }, [feesTemplateData]) as LaneFeesDetail
}

export default useGetDefaultLaneFeesData
